import React, { useContext, useEffect, useState } from 'react';
import { getAllProductsPerCategory, getConfig, updateConfig } from '../services/catalogServices';
import Toast from '../helpers/Toast';
import { AuthContext } from '../../context/Auth.context';
import Spinner from '../helpers/Spinner';
import { getActualDate } from '../functions/getActualDate';

const Config = () => {

    const [config, setConfigNew] = useState({
        printer_name: '',
        local_name: '',
        rfc: '',
        dir_1: '',
        dir_2: '',
        city: '',
        phone: '',
        email: '',
        label_products: '',
        cake_labels: false,
        cake_management: false,
        dlls_count_for_withdraw: false,
    });

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [list, setList] = useState([]);
    const { state, CheckResponse, setConfig } = useContext(AuthContext);
    const [modalPreview, setModalPreview] = useState(false);
    const [modalCategoryPreview, setModalCategoryPreview] = useState(false);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [productList, setProductList] = useState([]);

    const showToast = (t, d, tt) => {
        setList([...list, {
            id: Math.floor((Math.random() * 101) + 1),
            title: t,
            description: d,
            type: tt
        }]);
    }

    useEffect(() => {
        getConfig(state.auth).then(data => {
            CheckResponse(data);
            // console.log(data);
            if (data.code == 200) {
                setConfigNew(data.config);
                setSelectedProducts(data.config.label_products.split(',').map((id) => id.trim()));
            }
            setLoading(false);
        }).finally(getAllproducts());
    }, []);

    const getAllproducts = () => {
        getAllProductsPerCategory(state.auth).then(data => {
            CheckResponse(data);
            if (data.code == 200) {
                console.log(data)
                setProductList(
                    data.data.map(categoria => ({
                        ...categoria,
                        contraida: true,
                    })));
            }
        })
    }

    const changeSelectedCategory = (id, index, all) => {
        id = id.toString();
    
        setSelectedProducts((prevSelected) => {
            let newSelectedProducts = [];
            if (all === 0) {
                newSelectedProducts = prevSelected.includes(id)
                ? prevSelected.filter((categoryId) => categoryId !== id)
                : [...prevSelected, id];
            } else {
                newSelectedProducts = prevSelected.includes(id)
                ? [...prevSelected]
                : [...prevSelected, id];
            }
            checkCategoryProducts(index, newSelectedProducts);

            return newSelectedProducts;
        });
    };
    
    const checkCategoryProducts = (index, updatedSelectedProducts) => {
        const productsInArray = productList[index].products.map((product) => product.id.toString());
    
        setSelectedCategories((prev) => {
            if (productsInArray.every((product) => updatedSelectedProducts.includes(product))) {
                return prev.includes(index) ? prev : [...prev, index];
            } else {
                return prev.filter((categoryIndex) => categoryIndex !== index);
            }
        });
    };

    const updateCategoryLabelsConfig = () => {
        if (selectedProducts.length > 0) {
            setConfigNew({ ...config, label_products: selectedProducts.join(', ') });
        }
        setModalCategoryPreview(false)
    };

    const toggleCategoria = (index) => {
        const updatedProductList = [...productList];
        updatedProductList[index].contraida = !updatedProductList[index].contraida;
        setProductList(updatedProductList);
    };

    const toggleTodosProductos = (index) => {
        const updatedProductList = [...productList];
        updatedProductList[index].products.forEach((product) => {
            changeSelectedCategory(product.id, index, selectedCategories.includes(index) ? 0 : 1)
        });
        setProductList(updatedProductList);
    };

    const onSubmit = (e) => {
        e.preventDefault();
        setSaving(true);
        updateCategoryLabelsConfig();
        updateConfig(state.auth, config).then(data => {
            if (data.code == 200) {
                showToast('Hecho!', 'Guardado con exito!', 'success');
                setConfig(data.config);
            } else {
                showToast('Oops!', 'Algo salio mal!', 'danger');
            }
            setSaving(false);
        });
    }

    const openCategoriesModal = () => {
        const categorias = [...productList];
        categorias.forEach((cat, index) => {
            checkCategoryProducts(index, selectedProducts);
        });
        setModalCategoryPreview(true);
    }

    return (
        <>
            <div className="row">
                <div className="col-sm-12">
                    <h1>Configuración</h1>
                </div>
            </div>
            {!loading && <div className="row">
                <div className="col-sm-12">
                    <Toast
                        toastList={list}
                    />
                    <form name="loginForm" onSubmit={onSubmit}>
                        <div className="row">
                            <div className="col-sm-6 col-lg-3 mt-2">
                                <label className="form-label">Nombre de la Impresora</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    onChange={e => setConfigNew({ ...config, printer_name: e.target.value })}
                                    value={config.printer_name}
                                />
                            </div>
                            <div className="col-sm-6 col-lg-3 mt-2">
                                <label className="form-label">Nombre de la empresa</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    onChange={e => setConfigNew({ ...config, local_name: e.target.value })}
                                    value={config.local_name}
                                />
                            </div>
                            <div className="col-sm-6 col-lg-3 mt-2">
                                <label className="form-label">RFC</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    onChange={e => setConfigNew({ ...config, rfc: e.target.value })}
                                    value={config.rfc}
                                />
                            </div>
                            <div className="col-sm-6 col-lg-3 mt-2">
                                <label className="form-label">Dirección 1</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    onChange={e => setConfigNew({ ...config, dir_1: e.target.value })}
                                    value={config.dir_1}
                                />
                            </div>
                            <div className="col-sm-6 col-lg-3 mt-2">
                                <label className="form-label">Dirección 2</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    onChange={e => setConfigNew({ ...config, dir_2: e.target.value })}
                                    value={config.dir_2}
                                />
                            </div>
                            <div className="col-sm-6 col-lg-3 mt-2">
                                <label className="form-label">Ciudad</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    onChange={e => setConfigNew({ ...config, city: e.target.value })}
                                    value={config.city}
                                />
                            </div>
                            <div className="col-sm-6 col-lg-3 mt-2">
                                <label className="form-label">Telefono</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    onChange={e => setConfigNew({ ...config, phone: e.target.value })}
                                    value={config.phone}
                                />
                            </div>
                            <div className="col-sm-6 col-lg-3 mt-2">
                                <label className="form-label">Correo</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    onChange={e => setConfigNew({ ...config, email: e.target.value })}
                                    value={config.email}
                                />
                            </div>
                            <div className="col-sm-6 col-lg-3 mt-2">
                                <label className="form-label" htmlFor="name">Etiquetas de pasteles</label>
                                <div className="form-check form-switch">
                                    <input onChange={e => setConfigNew({ ...config, cake_labels: !config.cake_labels })} className="form-check-input" type="checkbox" checked={config.cake_labels ? 'checked' : ''}></input>
                                    <label className="form-check-label"></label>
                                </div>
                            </div>
                            <div className="col-sm-6 col-lg-3 mt-2">
                                <label className="form-label" htmlFor="name">Administrador de pasteles</label>
                                <div className="form-check form-switch">
                                    <input onChange={e => setConfigNew({ ...config, cake_management: !config.cake_management })} className="form-check-input" type="checkbox" checked={config.cake_management ? 'checked' : ''}></input>
                                    <label className="form-check-label"></label>
                                </div>
                            </div>
                            <div className="col-sm-6 col-lg-3 mt-2">
                                <label className="form-label" htmlFor="name">Los dlls cuenta para el retiro de caja</label>
                                <div className="form-check form-switch">
                                    <input onChange={e => setConfigNew({ ...config, dlls_count_for_withdraw: !config.dlls_count_for_withdraw })} className="form-check-input" type="checkbox" checked={config.dlls_count_for_withdraw ? 'checked' : ''}></input>
                                    <label className="form-check-label"></label>
                                </div>
                            </div>
                        </div>
                        {config.cake_labels == true && <>
                            <div className="row">
                                <div className="col-sm-6 mt-4">
                                    <div className="d-grid col-8">
                                        <button onClick={() => { openCategoriesModal() }} className="btn btn-outline-primary" type="button"><i className="bi bi-postage"></i> Seleccionar productos para etiquetas</button>
                                    </div>
                                </div>
                            </div>
                        </>}
                        <div className="row">
                            <div className="col-sm-6 mt-4">
                                <div className="d-grid gap-2 col-8 mx-auto">
                                    <button onClick={() => { setModalPreview(true) }} className="btn btn-primary" type="button"><i className="bi bi-eye"></i> Previsualizar recibo</button>
                                </div>
                            </div>
                            <div className="col-sm-6 mt-4">
                                {!saving && <div className="d-grid gap-2 col-8 mx-auto">
                                    <button className="btn btn-success" type="submit"><i className="bi bi-save"></i> Guardar</button>
                                </div>}
                                {saving && <div className="d-flex justify-content-center mt-4">
                                    <div className="spinner-border text-primary" style={{ "width": "5rem", "height": "5rem" }} role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </form>
                </div>
            </div>}
            <div className="modal fade show" style={{ background: "rgba(0, 0, 0, 0.8)", display: modalPreview ? 'block' : 'none' }}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header p-1 ps-3 pe-3">
                            <h1 className="modal-title fs-5">Previsualizar recibo</h1>
                            <button onClick={() => { setModalPreview(false) }} type="button" className="btn-close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                {config.local_name.length > 1 && <div className="row">
                                    <div className="col-sm-12 text-center">
                                        <h3>{config.local_name}</h3>
                                    </div>
                                </div>}
                                {config.rfc.length > 1 && <div className="row">
                                    <div className="col-sm-12 text-center">
                                        <label>{config.rfc}</label>
                                    </div>
                                </div>}
                                {config.dir_1.length > 1 && <div className="row">
                                    <div className="col-sm-12 text-center">
                                        <label>{config.dir_1}</label>
                                    </div>
                                </div>}
                                {config.dir_2.length > 1 && <div className="row">
                                    <div className="col-sm-12 text-center">
                                        <label>{config.dir_2}</label>
                                    </div>
                                </div>}
                                {config.city.length > 1 && <div className="row">
                                    <div className="col-sm-12 text-center">
                                        <label>{config.city}</label>
                                    </div>
                                </div>}
                                <hr></hr>
                                <div className="col-sm-12 text-center">
                                    <p>{getActualDate()}</p>
                                </div>
                                <hr></hr>
                                <div className="col-sm-12">
                                    <div className='row'>
                                        <div className="col-sm-8">
                                            <p className='text-start'> BOLILLO / TELERA</p>
                                        </div>
                                        <div className="col-sm-4">
                                            <p className='text-end'>$ 6.00</p>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-sm-12">
                                            <p className='text-end'>X2    $ 12.00</p>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-sm-8">
                                            <p className='text-start'> PLANCHA ZANAHORIA INTEGRAL</p>
                                        </div>
                                        <div className="col-sm-4">
                                            <p className='text-end'>$ 13.00</p>

                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-sm-12">
                                            <p className='text-end'>X2    $ 26.00</p>
                                        </div>
                                    </div>
                                </div>
                                {config.phone.length > 1 && <div className="row">
                                    <div className="col-sm-12 text-center">
                                        <label>{config.phone}</label>
                                    </div>
                                </div>}
                                {config.email.length > 1 && <div className="row">
                                    <div className="col-sm-12 text-center">
                                        <label>{config.email}</label>
                                    </div>
                                </div>}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-12 mt-2">
                                        <div className="d-grid gap-2">
                                            <button onClick={() => { setModalPreview(false) }} className="btn btn-primary btn-sm" type="button">Cerrar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade show" style={{ background: "rgba(0, 0, 0, 0.8)", display: modalCategoryPreview ? 'block' : 'none' }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header p-1 ps-3 pe-3">
                            <h1 className="modal-title fs-5">Categorias para etiquetas de productos</h1>
                            <button onClick={() => { updateCategoryLabelsConfig() }} type="button" className="btn-close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="container">
                                {productList?.map((item, index) => (
                                    <div className="mb-4" key={'Ct' + index}>
                                        <div className="d-flex align-items-center">
                                            <h3 onClick={() => { toggleCategoria(index) }} style={{ cursor: 'pointer' }} className="d-inline col-5">
                                                {!item.contraida ? ( <i className="bi bi-chevron-double-up me-2"></i>) : (
                                                    <i className="bi bi-chevron-double-down me-2"></i> )}
                                                {item.name}
                                            </h3>
                                            <div className="form-check form-switch col-6">
                                                <input
                                                    className="form-check-input mx-2"
                                                    type="checkbox"
                                                    onChange={() => {toggleTodosProductos(index)}}
                                                    id={`select-all-${item.name}`}
                                                    checked={selectedCategories.includes(index)}
                                                />
                                                <label className="form-check-label" htmlFor={`select-all-${item.name}`}>Todos los {item.name}</label>
                                            </div>
                                        </div>
                                        {!item.contraida && item.products.length > 0 && (
                                            <div className="list-group mt-2">
                                            <div className="row g-2">
                                                {item.products.map((product) => (
                                                    <div className="form-check form-switch col-12 col-sm-6 col-md-4" key={'Ck' + product.id}>
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id={'C' + product.id}
                                                            onChange={() => changeSelectedCategory(product.id, index, 0)}
                                                            checked={selectedProducts.includes(product.id.toString())}
                                                        />
                                                        <label className="form-check-label" htmlFor={'C' + product.id}>
                                                            {product.name}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                          </div>
                                        )}

                                        {!item.contraida && item.products.length === 0 && (
                                            <p className="mt-2">No hay productos en esta categoría.</p>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-12 mt-2">
                                        <div className="d-grid gap-2">
                                            <button onClick={() => { updateCategoryLabelsConfig() }} className="btn btn-primary btn-sm" type="button">Cerrar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {loading && <Spinner size={8} margin={4} ></Spinner>}

        </>
    );
}

export default Config;